import { useState, useEffect } from "react"; 
import { Box, Grid, GridItem, VStack, Button, Text } from "@chakra-ui/react";
import DynamicFormContainer from "components/CommonForm/DynamicFormContainer";
import ProfileCard from "components/CommonForm/ProfileCard";

const formConfig = [
  {
    id: "orderInfo",
    title: "Order Information",
    fields: [
      { name: "orderId", label: "Order ID", type: "text", required: true, gridSize: 6 },
      { name: "orderDate", label: "Order Date", type: "date", required: true, gridSize: 6 },
      { name: "deliveryDate", label: "Delivery Date", type: "date", required: true, gridSize: 6 },
      {
        name: "orderStatus",
        label: "Order Status",
        type: "select",
        options: ["New", "Completed", "Cancelled"],
        required: true,
        gridSize: 6,
      },
      { name: "clientName", label: "Client Name", type: "text", required: true, gridSize: 6 },
      {
        name: "assignedDriver",
        label: "Assigned Driver",
        type: "select",
        options: ["Driver 1", "Driver 2", "Driver 3"],
        gridSize: 6,
      },
      { name: "amount", label: "Amount", type: "number", required: true, gridSize: 6 },
    ],
  },
];

const AddOrder = ({ customerData }) => {
  const [formData, setFormData] = useState({
    orderId: customerData?.orderId || "",
    orderDate: customerData?.orderDate || "",
    deliveryDate: customerData?.deliveryDate || "",
    orderStatus: customerData?.orderStatus || "New",
    clientName: customerData?.fullname || "",
    assignedDriver: customerData?.assignedDriver || "",
    amount: customerData?.amount || "",
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (customerData) {
      setFormData((prevData) => ({
        ...prevData,
        orderId: customerData.orderId || prevData.orderId,
        orderDate: customerData.orderDate || prevData.orderDate,
        deliveryDate: customerData.deliveryDate || prevData.deliveryDate,
        orderStatus: customerData.orderStatus || prevData.orderStatus,
        clientName: customerData.clientName || prevData.clientName,
        assignedDriver: customerData.assignedDriver || prevData.assignedDriver,
        amount: customerData.amount || prevData.amount,
      }));
    }
  }, [customerData]);

  const validateForm = () => {
    let newErrors = {};
    formConfig[0].fields.forEach((field) => {
      if (field.required && !formData[field.name]) {
        newErrors[field.name] = "This field is required";
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      console.log("Final Payload:", JSON.stringify(formData, null, 2));
    }
  };

  return (
    <Box  mt={24}>
      <ProfileCard name={formData.clientName || "Client Name"} profileImage="" status={formData.orderStatus} />
      <Grid mt={4} templateColumns="1fr" gap={6} alignItems="start">
        <GridItem>
          <VStack spacing={6} align="stretch">
            <DynamicFormContainer
              key={formConfig[0].id}
              title={formConfig[0].title}
              cardData={formConfig[0]}
              formData={formData}
              setFormData={setFormData}
              errors={errors}
            />
          </VStack>
        </GridItem>
      </Grid>

      {Object.keys(errors).length > 0 && (
        <Text color="red.500" mt={4}>
          Please fix the errors before submitting.
        </Text>
      )}

      <Button mt={6}  bg="linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)"
          w="125px"
          h="35px"
          color="#fff"
          fontSize="xs"
          fontWeight="bold"
          alignSelf={{ sm: "flex-start", lg: null }}
          mb={{ sm: "12px", md: "0px" }}onClick={handleSubmit}>
        Submit
      </Button>
    </Box>
  );
};

export default AddOrder;
